import React from "react";
import { connect } from "react-redux";
import { Row, Label, Col } from "reactstrap";
import { Droppable } from "react-beautiful-dnd";
import { emailElementTabList } from "../models/emailElementTabList";
import ElementWrapper from "../../../components/element/ElementWrapper/ElementWrapper";
import ElementDropItem from "../../../components/editor/ElementDropItem/ElementDropItem";
import ElementDropItemWithImage from "../../../components/editor/ElementDropItem/ElementDropItemWithImage";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { emailElementType } from "../constants/emailElementType.constants";

export const EmailElements = () => {
  const elements = Array.from(emailElementTabList);
  return (
    <div className="element-list-aside" style={{ marginLeft: '10px' }}>
      <div style={{ margin: " 0px 2px" }}>
        <div
          style={{
            color: "#222",
            fontWeight: "600",
            fontSize: "10px",
            color: "rgb(81, 97, 103)",
            textTransform: "uppercase",
            borderBottom: "0px !important",
            wordBreak: "break-all",
            paddingBottom: '8px'
          }}
        >
          <SystemLabel name="SimpleElements" />
        </div>
      </div>
      <Droppable isDropDisabled={true} droppableId={"sidebar"}>
        {provided => (
          <div ref={provided.innerRef}>
            <Row style={{ margin: "0px", width: " 302px" }}>
              {elements.filter(el => el.group === emailElementType.SIMPLE).map((e, index) => {
                return (
                  <Col key={index} style={{ padding: "0px", paddingBottom: "5px" }}>
                    <ElementWrapper
                      key={index}
                      id={`${e.type}`}
                      index={index}
                    >
                      <ElementDropItem
                        customStyle={{ width: '147px', height: '100px' }}
                        draggableId={`${e.type}`}
                        name={e.label}
                        icon={e.thumbnail} />
                    </ElementWrapper>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </Droppable>
      <div style={{ margin: " 10px 2px" }}>
        <div
          style={{
            color: "#222",
            fontWeight: "600",
            fontSize: "10px",
            color: "rgb(81, 97, 103)",
            textTransform: "uppercase",
            borderBottom: "0px !important",
            wordBreak: "break-all",
            paddingBottom: '8px'
          }}
        >
          <SystemLabel name="MultiElements" />
        </div>
      </div>
      <Droppable isDropDisabled={true} droppableId={"sidebar"}>
        {provided => (
          <div ref={provided.innerRef}>
            <Row style={{ margin: "0px", width: " 302px" }}>
              {elements.filter(el => el.group === emailElementType.MULTI).map((e, index) => {
                return (
                  <Col key={index} style={{ padding: "0px", paddingBottom: "5px" }}>
                    <ElementWrapper
                      key={index}
                      id={`${e.type}`}
                      index={index}
                    >
                      <ElementDropItemWithImage
                        customStyle={{ width: '302px', height: 'auto' }}
                        draggableId={`${e.type}`}
                        name={e.label}
                        thumbnail={e.thumbnail} />
                    </ElementWrapper>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </Droppable>
    </div>
  );
}

